import Highcharts from 'highcharts/highstock';

import { FondsDetailConfig } from './FondsDetailConfig';
import AMApp from '../../../../../../../src/global/app';

export class FondsDetailChart {
  basePath;
  chartRoute;
  fondsAndiId;
  isGerman;
  extremesFlagWert;
  extremesFlagPrice;
  setExtremesWertCalled;
  selectedDateRange;

  constructor(element, options) {
    this.element = element;
    this.isGerman = true;

    this.chartWertentwicklung = {};
    this.chartPreisentwicklung = {};
    this.chartRoute = '?eID=fonds&function=chart&fondsId=';

    this.extremesFlagWert = false;
    this.extremesFlagPrice = false;
    this.setExtremesWertCalled = false;
    this.selectedDateRange = null;

    this.config = new FondsDetailConfig();
  }

  init(fondsDetailData) {
    //console.log('FondsDetailChart.init()', fondsDetailData);
    this.fondsDetailData = fondsDetailData;
    this.fondsAndiId = fondsDetailData.INSD_ANDI_ID;

    this.initEventListener();
    this.setHighChartsConfig();
  }

  renderFondsDetailChartWertentwicklung(chartData) {
    const seriesName = 'Wertentwicklung';
    const dataBVI = chartData.series_bvi;
    const dataBenchmark = chartData.series_bm;

    const gradientColors = this.getGradientColors();
    const colorStart = gradientColors[0];
    const colorEnd = gradientColors[1];

    let dataNavigation;
    let series = [{
      data: dataBVI,
      type: 'area',
      name: seriesName,
      visible: true,
      yAxis: 0,
      showInLegend: false,
    }, {
      data: dataBenchmark,
      type: 'area',
      name: 'Benchmark',
      yAxis: 0,
      showInLegend: false
    }];

    series = this.createSeries(chartData, series);

    if (chartData.series_bvi_nav) {
      dataNavigation = chartData.series_bvi_nav;
    }

    const options = {
      chart: {
        renderTo: 'fondsdetail_chart_wertentwicklung',
        zoomType: 'x',
        marginRight: 40,
        marginLeft: 0,
        height: 500,
        styledMode: false,
        events: {
          setExtremes: this.syncExtremes,
          afterSetExtremes: function(event) {
            this.afterSetExtremesWertentwicklung(event);
          }.bind(this),
        }
      },

      title: {
        text: null,
      },

      subtitle: {
        text: null,
      },

      rangeSelector: this.config.rangeSelector,

      navigator: {
        enabled: true,
        adaptToUpdatedData: false,
        handles: {
          height: 24,
          width: 20,
        },
        series: {
          data: dataNavigation,
          color: '#001729',
          fillOpacity: 0.3,
          dataGrouping: {
            enabled: true
          }
        },
      },

      xAxis: {
        type: 'datetime',
        events: {
          setExtremes: this.syncExtremes,
          afterSetExtremes: function(event) {
            this.afterSetExtremesWertentwicklung(event);
          }.bind(this),
        },
      },

      yAxis: [{
        labels: {
          formatter: function () {
            return Highcharts.numberFormat((this.value), 1, ',') + '%';
          },
          align: 'right',
          overflow: 'justify',
          x: 35,
          y: 2
        },
        plotLines: [{
          value: 0,
          width: 2,
          color: this.config.colors.primaryBlue,
          zIndex: 10
        }],
        opposite: true,
        minTickInterval: 0.1
      }],

      legend: {
        enabled: false
      },

      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, colorStart],
              [1, colorEnd]
            ]
          },
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: null
        },
      },

      defs: this.config.chartDefs,

      tooltip: {
        shared: true,  // Stellen Sie sicher, dass shared aktiviert ist, um this.points zu haben
        formatter: function () {
          const datum = Highcharts.dateFormat(AMApp.inputDateFormatHighCharts, this.x);
          let tooltipCont = '';
          let bviName = this.points[0].series.name;
          const bviValue = Highcharts.numberFormat((this.points[0].y * 1), 2, ',');

          tooltipCont += '<span style="font-size:10px;font-weight:bold">' + datum + '</span><br />';
          tooltipCont += '<span style="background-color:transparent;color:' + this.points[0].series.color + '">' + bviName + ': </span>';
          tooltipCont += '<span style="font-size:11px">' + bviValue + '%</span>';

          if (typeof this.points[1] !== 'undefined') {
            const bmName = this.points[1].series.name;
            let bmValue = Highcharts.numberFormat((this.points[1].y * 1), 2, ',');

            tooltipCont += '<br />';
            tooltipCont += '<span style="background-color:transparent;color:' + this.points[1].series.color + '">' + bmName + ': </span>';
            tooltipCont += '<span style="font-size:11px"> ' + bmValue + '%</span>';
          }

          return tooltipCont;
        },
        style: {
          backgroundColor: '#f7f7f7',
          color: '#001729',
        }
      },

      exporting: {
        buttons: {
          contextButton: {
            menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadPDF'],
          }
        }
      },

      responsive: this.config.chartResponsive,

      scrollbar: this.config.scrollbar,

      series: series,
    };

    this.chartWertentwicklung = Highcharts.chart(options);
  }

  /**
   *
   * @param data
   * @param series
   * @returns {*}
   */
  createSeries(data, series) {
    if (data.icma_data) {
      Object.entries(data.icma_data)
        .forEach(([key, item]) => {
          series.push({
            data: this.createICMASeriesData(data.series_bvi, item.series),
            name: item.label,
            type: 'area',
            visible: true,
            yAxis: 0,
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: 4,
              fillColor: this.config.icmaColors[key],
              lineWidth: 2,
            }
          });
        });
    }

    return series;
  }

  /**
   * Updates the date range selectors by toggling the 'gui--button__active' class
   * based on the provided range value. Removes the active class from all elements
   * and adds it to the element matching the specified range.
   *
   *                         to activate. If null or undefined, no element will
   *                         be activated.
   * @return {void} This method does not return a value.
   * @param range
   */
  updateDateRangeSelectors(range) {
    // Entferne die Klasse 'gui--button__active' von allen Elementen mit dem Attribut 'data-range'
    document.querySelectorAll('[data-range]')
      .forEach(el => {
        el.classList.remove('gui--button__active');
      });

    // Füge die Klasse 'gui--button__active' hinzu, wenn ein range-Wert vorhanden ist
    if (range) {
      const specificEl = document.querySelector('[data-range="' + range + '"]');
      if (specificEl) {
        specificEl.classList.add('gui--button__active');
      }
    }
  }

  /**
   *
   * @param seriesBVI
   * @param icmaData
   * @returns {*[]}
   */
  createICMASeriesData(seriesBVI, icmaData) {
    let seriesICMAData = [];

    seriesBVI.forEach(function (seriesItem) {
      icmaData.forEach(function (icmaDate) {
        if (seriesItem[0] === icmaDate) {
          seriesICMAData.push(seriesItem);
        }
      });
    });

    return seriesICMAData;
  }

  /**
   *
   * @param target
   * @param categories
   * @param series
   */
  createChartRsFlex(target, categories, series) {
    const options = {
      target: `#${target}`,
      exporting: { enabled: false },
      chart: {
        type: 'bar'
      },
      title: {
        text: ''
      },
      tooltip: {
        enabled: true,
        formatter: function () {
          return '<b>' + Highcharts.numberFormat((this.y), 2, ',') + ' %</b>';
        }
      },
      plotOptions: {
        series: {
          shadow: false,
          stacking: 'normal',
          animation: true
        },
        bar: {
          pointWidth: 12,
          borderRadius: 0,
          borderWidth: 0,
          pointPadding: 0,
          groupPadding: 0.5,
          dataLabels: {
            align: 'left',
            color: '#001729',
            distance: 20,
            overflow: 'none',
            crop: false,
            enabled: true,
            style: {
              fontSize: '12px',
              fontWeight: 'normal'
            },
            y: -15,
            x: 1,
            formatter: function () {
              if (this.y !== 0) {
                return this.x + ' <b>' + this.y + '%</b>';
              }

              return this.x;
            }
          }
        },
      },
      xAxis: {
        categories: categories,
        title: {
          text: null
        },
        labels: {
          align: 'right',
          enabled: false,
          style: {
            color: '#001729',
            fontSize: '13px'
          }
        }
      },
      yAxis: {
        tickPositions: [0, 25, 50, 75, 100],
        title: {
          text: null
        },
        labels: {
          enabled: true
        },
        showFirstLabel: true
      },
      legend: {
        enabled: false
      },
      series: []
    };

    options.series.push(series);

    Highcharts.chart(options);

  }

  prepareRequest(range, start, end, type) {
    let parameter = '';

    if (range) {
      parameter += '&range=' + range;
    }
    if (start) {
      parameter += '&start=' + start;
    }
    if (end) {
      parameter += '&end=' + end;
    }
    if (type) {
      parameter += '&type=' + type;
    }

    return this.chartRoute + this.fondsAndiId + parameter;
  }

  translateDateRange() {
    if (this.isGerman) {
      const dateRange = document.querySelectorAll('.fondsdetail-chart-graphic svg');
      if (dateRange[0]) {
        const textElement0 = dateRange[0].querySelector('text');
        if (textElement0) textElement0.textContent = 'von';
      }
      if (dateRange[1]) {
        const textElement1 = dateRange[1].querySelector('text');
        if (textElement1) textElement1.textContent = 'bis';
      }
      const rangeSelector = document.querySelector('[aria-label="Zeitraum"]');
    }
  }

  initEventListener() {
    document.addEventListener('DOMContentLoaded', () => {
      const charts = document.querySelectorAll('.js_fondsdetail_charts');
      charts.forEach(chartEl => {
        chartEl.addEventListener('mousemove', handleChartHover);
        chartEl.addEventListener('touchmove', handleChartHover);
        chartEl.addEventListener('touchstart', handleChartHover);
      });

      function handleChartHover(e) {
        let chart;
        let point;
        let i;
        let event;

        for (i = 0; i < Highcharts.charts.length; i += 1) {
          chart = Highcharts.charts[i];
          event = chart.pointer.normalize(e); // Find coordinates within the chart
          point = chart.series[0].searchPoint(event, true); // Get the hovered point

          if (point) {
            point.highlight(event);
          }
        }
      }
    });
  }

  setHighChartsConfig() {
    /**
     * Override the reset function, we don't need to hide the tooltips and crosshairs.
     */
    Highcharts.Pointer.prototype.reset = function () {
      return undefined;
    };

    /**
     * Highlight a point by showing tooltip, setting hover state and draw crosshair
     */
    // Highcharts.Point.prototype.highlight = function (event) {
    //   this.onMouseOver(); // Show the hover marker
    //   this.series.chart.tooltip.refresh(this); // Show the tooltip
    //   this.series.chart.xAxis[0].drawCrosshair(event, this); // Show the crosshair
    // };
  }

  syncExtremes(e) {
    // console.log('syncExtremes', e);
    this.extremesFlagPrice = true;
    this.extremesFlagWert = true;
    const thisChart = e.target.chart;

    // console.log('min', new Date(e.min).toLocaleDateString());

    if (e.trigger !== 'syncExtremes') { // Prevent feedback loop
      Array.forEach(Highcharts.charts, function (chart) {
        if (chart && chart !== thisChart) {
          if (chart.xAxis[0].setExtremes) { // It is null while updating
            chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, { trigger: 'syncExtremes' });
          }
        }
      });
    }
  }

  afterSetExtremesWertentwicklung(event) {
    // console.log('afterSetExtremesWertentwicklung', countSetExtremesWertentwicklung);
    this.setExtremesWertCalled = true;
    this.countSetExtremesWertentwicklung++;
    const chart = event.target.chart;
    const range = event.max - event.min;
    const start = Math.round(event.min) / 1000;
    const end = Math.round(event.max) / 1000;
    const request = this.prepareRequest(range, start, end, 'selector');

    if (event.trigger === 'rangeSelectorButton') {
      this.selectedDateRange = event.rangeSelectorButton.value;
    }

    chart.showLoading(AMApp.translations.common.loadData);

    fetch(request)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        const series = this.createSeries(data, []);

        // Update series Wertentwicklung
        chart.series[0].setData(data.series_bvi);

        // Update series benchmark
        chart.series[1].setData(data.series_bm);

        // Update series ICMA
        series.forEach((serie, index) => {
          chart.series[2 + index].setData(serie.data);
        });

        chart.redraw();
        chart.hideLoading();

        if (data.series_bm_last !== null) {
          this.setPerformanceDataWertentwicklung(data.series_bvi_last, data.series_bm_last);
        } else {
          this.setPerformanceDataWertentwicklung(data.series_bvi_last, null);
        }

        if (this.countSetExtremesWertentwicklung === 2) {
          this.countSetExtremesWertentwicklung = 0;
        }

        this.setExtremesWertCalled = false;

        // Rerender chart
        //amApp.prepareZusammensetzungChartData(AMApp.chartsDataStorage);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        chart.hideLoading();
      });
  }

  setPerformanceDataWertentwicklung(fondsLast, benchmarkLast) {
    let fLast;
    let bLast;
    let lastBVI;
    let lastBM;

    if (fondsLast) {
      fLast = fondsLast[1];
      lastBVI = Math.round(fLast * 100) / 100;
      //lastBVI = (lastBVI * 1);
      lastBVI = lastBVI.toFixed(2);
      lastBVI = lastBVI.replace('.', ',');

      document.getElementById('performance_fonds').innerHTML = lastBVI + ' %';
    }

    if (benchmarkLast) {
      bLast = benchmarkLast[1];
      lastBM = Math.round(bLast * 100) / 100;
      //lastBM = (lastBM * 1);
      lastBM = lastBM.toFixed(2);
      lastBM = lastBM.replace('.', ',');

      document.querySelectorAll('.js_benchmark').forEach(el => {
        el.style.display = 'block';
      });
      document.querySelectorAll('.js_fonds').forEach(el => {
        el.classList.add('developmentbox__fonds');
      });
      document.getElementById('performance_benchmark').innerHTML = lastBM + ' %';
    }
  }

  /********************************************************************
   * Preisentwicklung
   ********************************************************************/

  renderFondsDetailChartPreisentwicklung(data) {
    const seriesName = AMApp.translations.fondsdetail.chartPricePerformance
    const seriesData = data.series_price;

    const gradientColors = this.getGradientColors();
    const colorStart = gradientColors[0];
    const colorEnd = gradientColors[1];

    let dataNavigation;

    if (data.series_price_nav) {
      dataNavigation = data.series_price_nav;
    }

    const options = {
      chart: {
        renderTo: 'fondsdetail_chart_preisentwicklung',
        zoomType: 'x',
        marginRight: 55,
        marginLeft: 0,
        height: 500,
        styledMode: false,
        events: {
          load() {
            const chart = this;
            chart.showLoading(AMApp.translations.common.loadData);
            setTimeout(function() {
              chart.hideLoading();
            }, 3000);
          }
        }
      },

      // accessibility: {
      //   landmarkVerbosity: 'one',
      //   screenReaderSection: {
      //     beforeChartFormat: '<p>.</p>'
      //   },
      //   point: {
      //     valueDescriptionFormat: '{xDescription}, {value}.'
      //   },
      //   series: {
      //     pointDescriptionEnabledThreshold: false,
      //     describeSingleSeries: true,
      //   },
      //   keyboardNavigation: {
      //     enabled: true
      //   }
      // },

      title: {
        text: null
      },

      subtitle: {
        text: null
      },

      rangeSelector: this.config.rangeSelector,

      navigator: {
        enabled: true,
        adaptToUpdatedData: false,
        handles: {
          height: 24,
          width: 20,
        },
        series: {
          data: dataNavigation,
          color: "#001729",
          fillOpacity: 0.3,
          dataGrouping: {
            enabled: true
          }
        },
      },

      xAxis: {
        type: 'datetime',
        events: {
          setExtremes: this.syncExtremes,
          afterSetExtremes: function(event) {
            this.afterSetExtremesPreisentwicklung(event);
          }.bind(this),
        },
      },

      yAxis: [{
        labels: {
          formatter: function () {
            return Highcharts.numberFormat((this.value), 1, ',') + ' EUR ';
          },
          align: 'right',
          overflow: 'justify',
          x: 55,
          y: 2
        },
        plotLines: [{
          value: 0,
          width: 2,
          color: this.config.colors.primaryBlue,
          zIndex: 10
        }],
        opposite: true,
        minTickInterval: 0.1
      }],

      legend: {
        enabled: false
      },

      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, colorStart],
              [1, colorEnd]
            ]
          },
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: null
        },
      },

      defs: this.config.chartDefs,

      tooltip: {
        shared: true,
        formatter: function () {
          const datum = Highcharts.dateFormat(AMApp.inputDateFormatHighCharts, this.x);
          let tooltipCont = '';
          const preisName = this.points[0].series.name;
          const preisValue = Highcharts.numberFormat((this.points[0].y * 1), 2, ',');

          tooltipCont += '<span style="font-size:10px;font-weight:bold">' + datum + '</span><br />';
          tooltipCont += '<span style="background-color:transparent;color:' + this.points[0].series.color + '">' + preisName + ': </span>';
          tooltipCont += '<span style="font-size:11px">' + preisValue + ' EUR</span>';

          return tooltipCont;
        }
      },

      exporting: {
        buttons: {
          contextButton: {
            menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadPDF'],
          }
        }
      },

      responsive: this.config.chartResponsive,

      scrollbar: this.config.scrollbar,

      series: [
        {
          data: seriesData,
          type: 'area',
          name: seriesName,
          visible: true,
          yAxis: 0,
          showInLegend: false
        }
      ]
    };

    this.chartPreisentwicklung = Highcharts.chart(options);
  }

  afterSetExtremesPreisentwicklung(event) {
    const chart = event.target.chart;
    let range = event.max - event.min;
    let start = Math.round(event.min) / 1000;
    let end = Math.round(event.max) / 1000;
    let request = this.prepareRequest(range, start, end, 'selector');

    chart.showLoading(AMApp.translations.common.loadData);

    fetch(request)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP-Fehler: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        chart.series[0].setData(data.series_price);
        chart.redraw();

        if (this.extremesFlagPrice === false) {
          let extremesChart = chart.xAxis[0].getExtremes();
          chart.xAxis[0].setExtremes(extremesChart.dataMin, extremesChart.dataMax);
          this.extremesFlagPrice = true;
        }

        chart.hideLoading();
      })
      .catch(error => {
        console.error('Fehler beim Laden der Daten:', error);
        chart.hideLoading();
      });
  }

  getGradientColors() {
    const rootStyles = getComputedStyle(document.documentElement);
    const primaryBlueHex = rootStyles.getPropertyValue('--lbbw-primary-blue').trim() || '#001729';
    // Konvertiere Hex zu RGB (z. B. #001729 -> rgb(0,23,41))
    const rgbMatch = primaryBlueHex.match(/^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i)
      || [null, '00', '17', '29'];
    const r = parseInt(rgbMatch[1], 16);
    const g = parseInt(rgbMatch[2], 16);
    const b = parseInt(rgbMatch[3], 16);
    const colorStart = `rgba(${r}, ${g}, ${b}, 0.3)`;
    const colorEnd = `rgba(${r}, ${g}, ${b}, 0)`;
    return [colorStart, colorEnd];
  }


  debug() {
    const debugOutput = document.getElementById('debug');
    if (debugOutput) {
      const current = debugOutput.innerHTML;
      debugOutput.innerHTML = current + '<br>' + value;
    }
  }
}